module.exports = __webpack_public_path__ + "static/media/close_button.454cec1c.png";